import { Modal } from 'antd';
import Styles from './scss/upgarde.module.scss'
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import { useDispatcher } from '../../../custom_hooks/use_app_dispatch';
import { UserSettingsActions } from '../../../store/slices/settings_slice/user_settings_slice';
import { navigateToTicketing, openContactPage } from '../../../base/utils';
import plansupgd from '../../../../src/styles/images/upgradet.svg'

export function Upgdradeplan() {

  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const dispatch = useDispatcher()
  const close = () => {
    dispatch(UserSettingsActions.setUpgradePlan(false))
  }

  const open = () => {
    dispatch(UserSettingsActions.setUpgradePlan(false))
    navigateToTicketing()
  }

  if (loginUserCcaasDetail?.roleid == 3) {
    return (
      <Modal
        maskClosable={false}
        title={<span>Upgrade</span>}
        open={true}
        className="customModal sizeMD skilldisable sizemdwithht upgradeht"
        centered
        closeIcon={<span className="icon__Close16" ></span>}
        footer={false}
        onCancel={close}
      >
        {loginUserCcaasDetail?.roleid == 3
          ?
          <div className={Styles.upgradebg}>
            <div>
               <img src={plansupgd} alt="" />
            </div>
            <div className={Styles.growthplan}>
              <h3>Upgrade your plan to unlock this feature</h3>
              <div className={Styles.upgraebtn}>
                
              <button className={Styles.salest} onClick={openContactPage}>contact sales</button>
              {/* <button onClick={open}>Upgrade</button> */}

              </div>
            </div>
          </div>
          : <div className={Styles.growthplan}>
            <h3>Upgrade Required: Please contact your administrator to upgrade your plan and enable this feature</h3>
            <button onClick={close}>Close</button>
          </div>
        }
      </Modal>
    );
  } else {
    return (
      <Modal
        maskClosable={false}
        title={<span>Upgrade</span>}
        open={true}
        className="customModal sizeMD skilldisable sizemdwithht"
        centered
        closeIcon={<span className="icon__Close16" ></span>}
        footer={false}
        onCancel={close}
      >
        <div className={Styles.growthplan}>
          <h3>Upgrade Required: Please contact your administrator to upgrade your plan and enable this feature</h3>
          <button onClick={close}>Close</button>
        </div>
      </Modal>
    )
  }
}